import React from 'react';
import PropTypes from "prop-types";

function PricingCol({item}) {
  let price = new Money(item.price);

  return <td className="price">
    From {price.toString()}
  </td>
}

export default function PricingRow({items}) {
  return <tr>
    <th>Price</th>
    {items.map( item => <PricingCol item={item} key={item.id} />)}
  </tr>
}

PricingRow.propTypes = {
  items: PropTypes.array.isRequired,
}
